import CarouselWrapper from "../../shared/carousel-wrapper";
import { postRequest } from "../../../actions/api";
import { getAgentIds } from "../../shared/util";
import Overlay from "./overlay";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Slide from "./slide";
import {
  ACTIVE_LISTING_IMAGES,
  SOLD_LISTING_IMAGES,
} from "../../../constants/constants";
import _ from "lodash";

const placeholder = (
  <img
    style={{ width: "100%" }}
    src="/img/listing/transparent-16-9.png"
    alt="placeholder"
  />
);
class HeroSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backupImage: placeholder,
      filter: {
        agentSelect: true, //for solds
        agentId: getAgentIds(this.props.entity),
        heroImage: true,
        resultsPerPage: 48,
        sortField: "currentPrice",
        source: "sir",
      },
      width: 1200, //set higher than 1024 by default
    };
  }
  getHeroItems = () => {
    const options = this.props.entity.siteOptions
      ? this.props.entity.siteOptions.heroSliderOptions
      : {};
    if (!this.props.heroListings) {
      if (options.showType === ACTIVE_LISTING_IMAGES) {
        this.getActiveListings();
      } else if (options.showType === SOLD_LISTING_IMAGES) {
        this.getSoldListings();
      } else {
        this.getActiveListings();
      }
    }
  };

  componentDidMount() {
    const width = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    this.setState({ width: width });
    this.getHeroItems();
  }

  getActiveListings = () => {
    postRequest("/api/listings", this.buildFilter("active"))
      .then((results) => {
        if (results.resultCount === 0) {
          this.getSoldListings();
        } else {
          const { selectActiveListings } =
            this.props.entity.siteOptions.heroSliderOptions;
          if (selectActiveListings && selectActiveListings.length > 0) {
            this.formHeroListings(selectActiveListings, results, "active");
          } else {
            this.props.saveHeroListings(results.results);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  getSoldListings = () => {
    postRequest("/api/solds", this.buildFilter("sold"))
      .then((results) => {
        if (results.resultCount === 0) {
          this.setState({ backupImage: this.props.backupImage });
        } else {
          const { selectSoldListings } =
            this.props.entity.siteOptions.heroSliderOptions;
          if (selectSoldListings && selectSoldListings.length > 0) {
            this.formHeroListings(selectSoldListings, results, "solds");
          } else {
            this.props.saveHeroListings(results.results);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // to position listing based on the order selected in agen CMS site.
  formHeroListings(selectListingList, results, calledFrom) {
    let selectedListings = [];
    selectListingList.forEach((data) => {
      const result = _.find(results.results, function (n) {
        if (n.identifier === data.identifier) {
          return n;
        }
      });
      if (!!result) {
        selectedListings.push(result);
      }
    });
    if (
      calledFrom === "solds" &&
      selectListingList.length > this.props.defaultOptions.heroSoldListingsLimit
    ) {
      this.props.saveHeroListings(
        selectedListings.slice(
          0,
          this.props.defaultOptions.heroSoldListingsLimit
        )
      );
    } else {
      this.props.saveHeroListings(selectedListings);
    }
  }

  buildFilter = (type) => {
    let filter = { ...this.state.filter };
    const { selectActiveListings, selectSoldListings } =
      this.props.entity.siteOptions.heroSliderOptions;
    if (type === "active") {
      if (selectActiveListings && selectActiveListings.length > 0) {
        filter.include = selectActiveListings.map((l) => l.identifier);
      }
    } else if (type === "sold") {
      if (selectSoldListings && selectSoldListings.length > 0) {
        filter.include = selectSoldListings.map((l) => l.identifier);
        filter.resultsPerPage = selectSoldListings.length;
      } else {
        filter.resultsPerPage = this.props.defaultOptions.heroSoldListingsLimit;
      }
    }
    return filter;
  };

  render() {
    const numSlides = this.props.heroListings && this.props.heroListings.length;
    return numSlides ? (
      <div className="hero-slider">
        <CarouselWrapper
          slides={this.props.heroListings.map((l, index) => (
            <Slide
              numSlides={numSlides}
              listing={l}
              key={index}
              index={index}
              width={this.state.width}
              heroOptions={this.props.entity.siteOptions.heroSliderOptions}
            />
          ))}
        />
        <Overlay
          heroOptions={this.props.entity.siteOptions.heroSliderOptions}
          region={this.props.region}
        />
      </div>
    ) : (
      this.state.backupImage
    );
  }
}

HeroSlider.propTypes = {
  entity: PropTypes.object.isRequired,
  backupImage: PropTypes.node.isRequired,
  defaultOptions: PropTypes.object.isRequired,
  heroListings: PropTypes.array,
  region: PropTypes.string.isRequired,
  saveHeroListings: PropTypes.func.isRequired,
};

export default HeroSlider;



// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/hero-slider.js